module.exports = __webpack_public_path__ + "public/StoreIcon/orderManagement.svg?c93887c6";